import { Photos } from "@/config";

export const resizeForAiIdentification = (file: File): Promise<File> => resizeImageFile(file, Photos.aiIdentificationMaxSize, Photos.aiIdentificationMaxSize);

export const resizeForCollectionItemPhoto = (file: File): Promise<File> => resizeImageFile(file, Photos.galleryPhotoMaxSize, Photos.galleryPhotoMaxSize);

export const resizeImageFile = async (file: File, maxWidth: number, maxHeight: number): Promise<File> => {
  if (!file.type.startsWith("image/")) {
    return file;
  }

  let bitmap: ImageBitmap;
  try {
    bitmap = await createImageBitmap(file);
  } catch {
    return file; // unsupported format (e.g. HEIC) - send as-is
  }

  const scale = Math.min(1, maxWidth / bitmap.width, maxHeight / bitmap.height);
  if (scale >= 1) {
    bitmap.close();
    return file; // already within bounds
  }

  const width = Math.round(bitmap.width * scale);
  const height = Math.round(bitmap.height * scale);

  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext("2d");
  if (!ctx) {
    bitmap.close();
    return file;
  }
  ctx.drawImage(bitmap, 0, 0, width, height);
  bitmap.close();

  const blob = await new Promise<Blob | null>((resolve) => canvas.toBlob(resolve, file.type, 0.9));
  if (!blob) {
    return file;
  }

  return new File([blob], file.name, { type: file.type, lastModified: file.lastModified });
};
